<template>
  <!-- TODO: for some reason adding fade as a bound class doesn't work -->
  <div
    class="modal"
    :class="{ fade: true }"
    ref="modalElem"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      :class="[
        {
          'modal-dialog-scrollable': modifiers.scrollable,
          'modal-dialog-centered': modifiers.centered,
        },
        modifiers.sizeClass,
      ]"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="modifiers.title" class="modal-title">{{ modifiers.title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <component
            :is="template || modifiers.template"
            v-bind="modifiers.props"
          ></component>
        </div>
        <div v-if="modifiers.footer" class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { useUtilitiesStore } from '../../store'

const modalElem = ref(null)
const utilities = useUtilitiesStore()
const isOpen = computed(() => utilities.modalIsOpen)

const options = computed(() => utilities.modalOptions || {})
const modifiers = computed(() => utilities.modalModifiers || {})
const template = computed(() => utilities.template || null)
const modal = ref(null)

watch(isOpen, () => {
  if (isOpen.value) {
    modal.value = new bootstrap.Modal(modalElem.value, options.value)
    modal.value.show()
  } else {
    modal.value.hide()
  }
})

onMounted(() => {
  document.addEventListener('hidden.bs.modal', () => {
    utilities.closeModal()
    utilities.clearModal()
  })

  document.addEventListener('hide.bs.modal', () => {
    if (modifiers.value.closeCallback) modifiers.value.closeCallback()
  })
})
</script>
